import { Outlet } from 'react-router-dom';

function Properties(){
    return(
        <Outlet/>
    );
}

export default Properties;
  